// @ts-nocheck
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { LoginForm } from './common/LoginForm/LoginForm'
import { NewPasswordForm } from './common/NewPasswordForm/NewPasswordForm'
import { ResetPasswordForm } from './common/ResetPasswordForm/ResetPasswordForm'
import { AuthLayout } from './../layout/AuthLayout/AuthLayout'

import {
  LOGIN,
  PASSWORD_CHANGE,
  PASSWORD_CHANGE_DONE,
  PASSWORD_RESET,
  getLocation,
  toLogin,
} from 'ducks/router'

const LoginRoutes = () => {
  const location = useSelector(getLocation)
  const dispatch = useDispatch()

  const { type } = location

  switch (type) {
    case LOGIN:
      return <LoginForm />
    case PASSWORD_RESET:
      return <ResetPasswordForm />
    case PASSWORD_CHANGE:
    case PASSWORD_CHANGE_DONE:
      return <NewPasswordForm />
    default:
      setTimeout(() => dispatch(toLogin()), 0)

      return <LoginForm />
  }
}

export const LoginPage = () => (
  <AuthLayout>
    <LoginRoutes />
  </AuthLayout>
)